import React, { useEffect, useState } from "react";
import { PatternlibTextinput } from "@liebherr/patternlib-react";
import PropTypes from "prop-types";

const Input = ({
  step,
  type,
  placeholder,
  name,
  onChange,
  variable,
  data,
  width,
}) => {
  const [value, setValue] = useState("");

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      const calculatedValue = calculateValue(value);
      setValue(calculatedValue);
      updateValues({ variable, value: calculatedValue });
    }
  };

  const calculateValue = (val) => {
    // Check if the input contains a calculation (e.g., "12 + 4")
    if (
      val.includes("+") ||
      val.includes("-") ||
      val.includes("*") ||
      val.includes("/")
    ) {
      try {
        // Use eval to calculate the expression
        return eval(val);
      } catch (error) {
        // Handle invalid calculations gracefully
        return val;
      }
    } else {
      // If it's just a number, return it as is
      return val;
    }
  };

  const onChangeListener = (event) => {
    const val = event.target.value;
    setValue(val);
  };

  const onBlurListener = () => {
    const calculatedValue = calculateValue(value);
    setValue(calculatedValue);
    updateValues({ variable, value: calculatedValue });
  };
  // call function on blur
  const updateValues = (value) => {
    if (value?.value !== undefined) {
      onChange(value);
    }
  };

  useEffect(() => {
    setValue(data["resolvedVal"]);
  }, [data]);

  return (
    <>
      <PatternlibTextinput
        placeholder={placeholder}
        name={name}
        type={type}
        min={data.min}
        max={data.max}
        step={step}
        value={value}
        onLhBlur={onBlurListener}
        onLhChange={onChangeListener}
        show-remove-icon="false"
        onKeyDown={handleKeyDown}
        width={width}
      ></PatternlibTextinput>
    </>
  );
};

Input.propTypes = {
  placeholder: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  variable: PropTypes.string,
  data: PropTypes.any,
  width: PropTypes.string,
};

Input.defaultProps = {
  placeholder: "",
  width: "100%",
};

export default Input;
